if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.openTermsLink = this.querySelector('.js-open-terms-link');
      this.modal = this.querySelector('.js-terms-modal');
      this.closeModalBtn = this.querySelector('.js-close-terms-modal');

      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));

      this.submitHandler = this.handleSubmit.bind(this);
      this.openModalHandler = this.openModal.bind(this);
      this.closeModalHandler = this.closeModal.bind(this);
      this.windowClickHandler = this.windowClick.bind(this);

      if (this.form) this.form.addEventListener('submit', this.submitHandler);
      if (this.openTermsLink) this.openTermsLink.addEventListener('click', this.openModalHandler);
      if (this.closeModalBtn) this.closeModalBtn.addEventListener('click', this.closeModalHandler);
      window.addEventListener('click', this.windowClickHandler);
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.submitHandler);
      if (this.openTermsLink) this.openTermsLink.removeEventListener('click', this.openModalHandler);
      if (this.closeModalBtn) this.closeModalBtn.removeEventListener('click', this.closeModalHandler);
      window.removeEventListener('click', this.windowClickHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        alert(theme.strings.cartTermsConfirmation || "Please accept the Terms and Conditions before continuing.");
      }
    }

    openModal(evt) {
      evt.preventDefault();
      this.modal.style.display = 'block';
      document.documentElement.style.overflow = 'hidden';
      const cartSummary = document.getElementById('cart-summary');
      if (cartSummary) {
        cartSummary.style.zIndex = '999';
      }
    }

    closeModal() {
      this.modal.style.display = 'none';
      document.documentElement.style.overflow = '';
      const cartSummary = document.getElementById('cart-summary');
      if (cartSummary) {
        cartSummary.style.zIndex = '';
      }
    }

    windowClick(evt) {
      if (evt.target === this.modal) {
        this.closeModal();
      }
    }
  }

  customElements.define('cart-terms', CartTerms);
}